import styled from 'styled-components';
import { FormError as ToolkitFormError } from '@cko/primitives';
/**
 * @deprecated - Errors should be handled internally within Toolkit input components. Use the appropriate Toolkit component directly
 */
export const FormError = styled(ToolkitFormError) `
  margin-bottom: var(--layout-sandgrain);
`;
